import i18next from 'i18next';

i18next.addResources('en', 'BottleHeader', {
  signUp: 'Sign Up For Our Latest News'
});
